import * as React from "react";
import { forwardRef } from "react";
const SvgDragIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3 7.5H15M3 10.5H15M6.75 13.5L9 15.75L11.25 13.5M6.75 4.5L9 2.25L11.25 4.5", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgDragIcon);
export { ForwardRef as ReactComponent };
